import { render, staticRenderFns } from "./updateBeneficiarySummary.vue?vue&type=template&id=6ec49293&scoped=true"
import script from "./updateBeneficiarySummary.vue?vue&type=script&lang=js"
export * from "./updateBeneficiarySummary.vue?vue&type=script&lang=js"
import style0 from "./updateBeneficiarySummary.vue?vue&type=style&index=0&id=6ec49293&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec49293",
  null
  
)

export default component.exports